import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=2604f4ec&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=2604f4ec&scoped=true&lang=scss&"
import style1 from "./Cards.vue?vue&type=style&index=1&id=2604f4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604f4ec",
  null
  
)

export default component.exports